export default function CareerCard({ jobTitle, jobDescription, facebookLink, datePosted }) {
    return (
        <div className="bg-white shadow-md rounded-sm overflow-hidden max-w-md transition-transform transform hover:scale-105 hover:shadow-lg">
            {/* Gold line at the top */}
            <div className="h-2 bg-yellow-500"></div>

            <div className="p-6">
                <h3 className="text-3xl font-semibold text-gray-800 mb-2">{jobTitle}</h3>
                <p className="text-gray-600 mb-4">{jobDescription}</p>
                <p className="text-sm text-gray-400 mb-4">Posted on: {datePosted}</p>
                <a
                    href={facebookLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block text-blue-600 hover:text-blue-800 font-medium"
                >
                    Read More →
                </a>
            </div>
        </div>
    );
}
